import { render } from "./ConfirmCode.vue?vue&type=template&id=66d8b794&scoped=true"
import script from "./ConfirmCode.vue?vue&type=script&lang=js"
export * from "./ConfirmCode.vue?vue&type=script&lang=js"

import "./ConfirmCode.vue?vue&type=style&index=0&id=66d8b794&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d8b794"]])

export default __exports__